var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',[_vm._v(" This is a test widget "),_c('pre',[_vm._v(_vm._s(_vm.store))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }